import {
    RouteLocationInterface,
    RouteHttpVerb,
    RouteResponseInterface,
    RouteRequestInterface,
    RouteParamsInterface
} from "@wpnotes/utils";
import { TodoModel } from "../models";

export const locationRestTodoGet: RouteLocationInterface = {
    path: "/todo",
    method: RouteHttpVerb.GET
};

export type RequestRouteTodoGet = RouteRequestInterface;

export type ParamsRouteTodoGet = RouteParamsInterface;

export interface ResponseRouteTodoGet extends RouteResponseInterface {
    data: TodoModel[];
    currentPage: number;
    total: number;
    errors: string[];
}
